import { Button } from '@mui/material'
import { Theme } from 'theme/theme'
import ProductListTable from '../ProductListTable'
import { Product } from '@Arti-zen/package-backoffice'
import { Title } from 'modules/product/UploadProducts/ArtisanUploadProducts'

type TProps = {
  csv: string
  products: Product[]
  onModify: boolean
}

export default function ProductsAfterUploading({ csv, products, onModify }: TProps) {
  const downloadCSV = async () => {
    const blob = new Blob(['\uFEFF' + csv], {
      type: 'text/csv;charset=utf-8',
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = onModify ? 'produits-modifies.csv' : 'produits-importes.csv'
    link.click()
    URL.revokeObjectURL(url)
  }
  return (
    <>
      {csv && (
        <Button
          onClick={downloadCSV}
          style={{
            backgroundColor: Theme.colors.greenArtizen,
            color: 'white',
          }}
        >
          Télécharger le fichier CSV des produits {onModify ? 'modifiés' : 'importés'}
        </Button>
      )}
      <Title>
        Produits {onModify ? 'modifiés' : 'importés'} : {products?.length ?? '0'}
      </Title>
      <ProductListTable data={products} correctProduct={() => {}} openForm={() => {}} onModify={onModify} />
    </>
  )
}
